




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AccountData } from '../classes/accountData';
import PhoneInput from 'modules/core/components/forms/PhoneInput.vue';
import { Languages } from 'modules/core/enums/languages';
import { ElForm } from 'element-ui/types/form';
import { Integrations } from '../enums/integrations';
import { Action } from 'vuex-class';

@Component({
  components: {
    PhoneInput,
  },
})
export default class Register extends Vue {
  @Prop() public data!: AccountData;
  @Prop() public integration!: Integrations;
  public form: AccountData = new AccountData();
  @Prop() public accountExist!: boolean;
  public termsAccepted: boolean = false;
  public formRules!: any;
  public phoneModel: any = {
    phone: '',
    code: undefined,
  };
  public countries: any[] = [
    {
      label: 'Polski',
      value: Languages.PL,
    },
    {
      label: 'English',
      value: Languages.EN,
    },
  ];  

  @Action('auth/setUserLanguage') private setUserLanguage!: (
    token: string,
  ) => void;

  public created() {
    this.form = this.data;

    if (this.data.phone) {
      this.phoneModel.phone = this.data.phone.slice(3);
      this.phoneModel.code = this.data.phone.replace(' ','+').slice(0, 3);
    }

    this.formRules = this.createValidationRules();
  }

  public createValidationRules() {
    return {
      name: [
        { required: true, message: this.$t('forms.missingField', { field: this.$t('wizard.account.name') }), trigger: 'blur' },
      ],
      email: [
        { required: true, message: this.$t('forms.missingField', { field: this.$t('wizard.account.email') }), trigger: 'blur' },
        { type: 'email', required: true, message: this.$t('forms.invalidEmail'), trigger: 'blur' },
      ],
      phone: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if ((this.$refs.phoneInput as PhoneInput).validate()) {
              callback();
            } else {
              callback(new Error(this.$t('forms.wrongPhone') as string));
            }
          },
        },
      ],
      lang: [
        { type: 'string', required: true, message: this.$t('forms.required'), trigger: 'change' },
      ],
      termsAccepted: [
        { trigger: 'change',
          validator: (rule: any, value: boolean, callback: (error?: Error) => void) => {
            if (this.termsAccepted) {
              callback();
            } else {
              callback(new Error(this.$t('forms.acceptTerms') as string));
            }
          },
        },
      ],
    };
  }

  public updatePhoneNumber(val: any) {
    this.form.phone = val.code + val.phone;
    this.phoneModel = val;
    this.updateAccountData();
  }

  public updateEmail(val: any) {
    this.$emit('checkEmail', this.form.email);
    this.updateAccountData();
  }

  public updateAccountData() {
    this.$emit('update', this.form);
  }

  public updateLang() {
    this.updateAccountData();
    this.$i18n.locale = this.data.lang;
    this.setUserLanguage(this.data.lang);
    this.formRules = this.createValidationRules();
  }

  public async validateForm() {
    return new Promise((resolve, reject) => {
      (this.$refs.form as ElForm).validate((isValid: boolean, invalidFields: object) => {
        if (!isValid) {
          let errors = '';
          for (const field in invalidFields) {
            if (field) {
              // @ts-ignore
              const settings: any = invalidFields[field];
              for (const sett of settings) {
                errors += `<p>${sett.message}</p>`;
              }
            }
          }

          this.$message({
            message: errors,
            type: 'error',
            dangerouslyUseHTMLString: true,
          });
        }

        resolve(isValid);
      });
    });
  }

  public goToLogin() {
    this.$emit('goToLogin', true);
  }
}
